import axios from 'axios';

import {
  WORK_AGREEMENTS_BALANCE_BUDGET,
  WORK_AGREEMENTS_BALANCE_BUDGET_TRANSACTIONS
} from 'RestAPIs/endpoints';

type BudgetData = {
  year: number;
  month: number;
  availableExtraStatutoryLeaveHours: number;
  availablePlbHours: number;
  availablePlusHours: number;
  planningHours: number;
  salaryHours: number;
  maxAllowedHours: number;
  totalHours: number;
  availableHours: number;
  plbName: string;
};

export type TransactionType =
  | 'EXTRA_STATUTORY_LEAVE'
  | 'PLB'
  | 'PLUS_HOURS'
  | 'MANUAL'
  | 'SALARY_EXPORT'
  | 'WITHDRAWAL'
  | 'GIFT';

type TransactionPostBody = {
  type: TransactionType;
  hours: number;
};

export type TransactionResponse = {
  type: TransactionType;
  createdBy: string;
  hours: number;
  name: string;
  createdOn: string;
  canBeCredited: boolean;
  id: number | string;
};

export const getData = (workAgreementId: number) =>
  axios.get<BudgetData>(WORK_AGREEMENTS_BALANCE_BUDGET, {
    pathParams: { workAgreementId }
  });

export const getTransactions = (workAgreementId: number) =>
  axios.get<TransactionResponse[]>(
    WORK_AGREEMENTS_BALANCE_BUDGET_TRANSACTIONS,
    {
      pathParams: { workAgreementId }
    }
  );

export const setTransaction = (
  workAgreementId: number,
  body: TransactionPostBody
) =>
  axios.post(
    WORK_AGREEMENTS_BALANCE_BUDGET_TRANSACTIONS,
    { ...body },
    {
      pathParams: { workAgreementId }
    }
  );

export const creditTransaction = (workAgreementId: number, transactionId) =>
  axios.put(
    `${WORK_AGREEMENTS_BALANCE_BUDGET_TRANSACTIONS}/:transactionId/credit`,
    null,
    {
      pathParams: { workAgreementId, transactionId }
    }
  );
